// EmailJS Configuration
export const EMAILJS_CONFIG = {
    PUBLIC_KEY: 'FQZbFqUisI5yBqDjp', // Ganti dengan Public Key Anda
    SERVICE_ID: 'service_7td0ipe', // Ganti dengan Service ID
    TEMPLATES: {
        AI_CONSULTATION: 'template_zjmqn7h',
        DEMO_REQUEST: 'template_dwq98zg',
    }
};

// WhatsApp Configuration
export const WHATSAPP_CONFIG = {
    BUSINESS_NUMBER: '6285648898807', // Nomor WhatsApp Anda
    DEFAULT_MESSAGE: 'Halo EcoGuard AI, saya tertarik dengan solusi energi dan air.'
};